import { render, staticRenderFns } from "./Slide4.vue?vue&type=template&id=504b652a&scoped=true&"
import script from "./Slide4.vue?vue&type=script&lang=js&"
export * from "./Slide4.vue?vue&type=script&lang=js&"
import style0 from "./Slide4.vue?vue&type=style&index=0&id=504b652a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504b652a",
  null
  
)

export default component.exports